import { useLocation } from "wouter";

import { COLOR, textGradient } from "../../common/css/colors";
import { Button } from "../atoms";

const PlatformHeader = () => {
    const [, setLocation] = useLocation();

    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                paddingInline: "2em",
                paddingBlock: "1em",
            }}
        >
            <a href="/" style={{ textDecoration: "none" }}>
                <h1
                    style={{
                        ...textGradient(COLOR.teal3, COLOR.lime3),
                        userSelect: "none",
                    }}
                >
                    questie
                </h1>
            </a>

            <div>
                <Button
                    text="Quests"
                    style={{ marginRight: "1em" }}
                    onClick={() => setLocation("/questlog")}
                />
                <Button
                    text="Settings"
                    onClick={() => setLocation("/settings")}
                />
            </div>
        </div>
    );
};

export default PlatformHeader;
